var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "eye_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eye_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.251 10.5a20.25 20.25 0 0 0-18.71 12.504.75.75 0 0 0 0 .49 20.25 20.25 0 0 0 37.42 0 .75.75 0 0 0 0-.49A20.25 20.25 0 0 0 23.251 10.5Zm-12.654 1.344A22.75 22.75 0 0 1 44.3 22.118c.27.73.27 1.532 0 2.262l-.008.022-.008.02a22.75 22.75 0 0 1-42.08-.042 3.25 3.25 0 0 1 .016-2.304 22.75 22.75 0 0 1 8.378-10.232Zm5.404 11.405a7.25 7.25 0 0 1 8.877-7.067 3.5 3.5 0 0 0 5.217 4.667 7.25 7.25 0 1 1-14.093 2.4Z",
    fill: "#004152"
  }))));
};
export default SvgEye;